//region 1. Platform Libraries
import bodyParser from 'body-parser';
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
//endregion

const context = {
        router: express.Router({ mergeParams: true }),
        cameras: null,
        logger: null,
};

context.router.put('/', bodyParser.json());
context.router.put('/', checkObjectID);
context.router.put('/', checkStreamIndex);
context.router.put('/', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
        log('debug', JSON.stringify(req.body, null, 2));
        if (!{}.hasOwnProperty.call(req.body, 'status')) {
                const message = 'No Status';
                log('error', message);
                res.status(400).send(message);
                return;
        }
        const diff = {};
        diff[`streams.${req.params.index}.status.event`] = {
                message: req.body.status,
                updated: new Date(),
        };
        const _id = new MongoClient.ObjectID(req.params.id);
        context.cameras.updateOne({ _id }, { $push: diff }, (err, result) => {
                if (err) {
                        log('error', err.message);
                        res.status(500).send(err.message);
                        return;
                }
                if (!result.matchedCount) {
                        const message = 'Camera Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                log('info', '200 OK');
                res.sendStatus(200);
        });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/event-status
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountEventStatus(options) {
        context.logger = options.logger;
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountEventStatus' });
        log('debug', 'Mounting router for /c/:/s/:/event-status....');
        options.app.use('/cameras/:id/streams/:index/event-status', context.router);
        context.cameras = options.database.collection('cameras');
        log('info', 'Router for /c/:/s/:/event-status Mounted');
}
